import { type DocumentReference } from 'firebase/firestore';

import { DocumentType } from 'types/DocumentType';

import { DocumentSchema } from './DocumentSchema';
import DocumentStore from './DocumentStore';

export class BreadcrumbSchema extends DocumentSchema {}

export interface NamedItem {
    name: string;
}

export default class Breadcrumb extends DocumentStore<NamedItem, NamedItem> {
    schema = new BreadcrumbSchema();
    type = DocumentType.NONE;
    url = '';

    constructor(parent: unknown, docRef?: DocumentReference) {
        super(parent, docRef);
        this.becomeObservable();
    }

    get name() {
        // A crumb whose document is missing (typically a public/info that
        // was never written) shows as a bare warning sign: easy to spot and
        // report. BreadcrumbManager logs the path.
        if (!this.exists) return '⚠️';
        return this.data?.name;
    }

    setType = (documentType: DocumentType) => {
        this.type = documentType;
    };

    setUrl = (url: string) => {
        this.url = url;
    };
}
